// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"79a03e2ad915302d5794","147":"a3c54e2d6758041222e4","251":"bf29dcfa8c04c236e05a","265":"bdab3b8250d5ce5ad886","352":"6e7efe2c21f281fba965"}[chunkId] + ".js";
};